import * as React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';


function Filters({ Title, page, data, handleChangeFilter, employeeDataFilter, filterEmployee, period, employeeSelected, selectedEmployee, setSelectedPeriod, objPeriod, viewEmployees, selectedDepartment }) {

    const [age, setAge] = React.useState('');

    const handleChange = (event) => {
        if (Title == 'Departamento') {
            setAge(event.target.value);
            handleChangeFilter(event);
        }
        if (Title == 'Colaborador') {
            setAge(event.target.value)
            selectedEmployee(event);
        }
        if (Title == 'Periodo') {
            setAge(event.target.value)
            setSelectedPeriod(event.target.value);
            objPeriod();
        }
        setAge(event.target.value)
    };

    return (
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{Title}</InputLabel>
            <Select
                sx={{
                    width: '100%', borderRadius: '20px', backgroundColor: '#ebebeb', '.MuiOutlinedInput-notchedOutline': { border: 0 }
                }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={page == 0 ? age : Title == 'Colaborador' ? employeeSelected ? employeeSelected : employeeDataFilter.length > 0 ? employeeDataFilter[0].name : age : selectedDepartment}
                label={Title}
                onChange={handleChange}
            >
                {
                    Title == 'Colaborador' && filterEmployee ?
                        employeeDataFilter.map(dt => (
                            <MenuItem
                                key={dt.id}
                                value={dt.name}
                            >
                                {dt.name}
                            </MenuItem>))
                        :

                        data.map(dt => (
                            <MenuItem key={dt.id} value={dt.name} style={{color:dt.name == 'VER TODOS FUNCIONÁRIOS'? '#537ccd' : 'black'}}>
                                {dt.name}
                            </MenuItem>
                        ))
                }
            </Select>
        </FormControl>
    )
}
export default Filters;